import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Question } from "@phosphor-icons/react";

/**
 * Small, non-blocking "?" icon that opens a contextual advice popover.
 * Renders inline; does not steal focus from adjacent inputs.
 */
export default function InfoTip({ title, children, testId, side = "top" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          tabIndex={-1}
          aria-label={`Suggerimento: ${title || "Info"}`}
          className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-white/5 border border-white/10 text-zinc-500 hover:text-cyan-400 hover:border-cyan-400/40 transition-colors align-middle"
          data-testid={testId || "info-tip"}
          onClick={(e) => e.stopPropagation()}
        >
          <Question size={10} weight="bold" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        className="w-72 rounded-none bg-zinc-950 border-white/15 text-zinc-100 p-4 z-[60]"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        {title && (
          <div className="font-mono-data text-[10px] tracking-widest text-cyan-400 mb-2">
            {title.toUpperCase()}
          </div>
        )}
        <div className="text-xs text-zinc-300 leading-relaxed">{children}</div>
      </PopoverContent>
    </Popover>
  );
}
